import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";

import videoone from "../../Assets/Composite.mp4";
import videotwo from "../../Assets/Spiderman.mp4";
import videothree from "../../Assets/spidervspigeon.mp4";
import videofour from "../../Assets/Batmobile.mp4";
import videofive from "../../Assets/Batman_Theme_Song.mp4";
import videosix from "../../Assets/box.mp4";
import videoseven from "../../Assets/LopezDonald.mp4";
import videoeight from "../../Assets/LopezDonaldproj5.mp4";
import videonine from "../../Assets/Particleswsound.mp4";
import videoten from "../../Assets/spiderdropsounds.mp4";

import imagethirtyfive from "../../Assets/spiderman1.png";
import imagethirtysix from "../../Assets/spiderman2.png";
import imagethirtyseven from "../../Assets/spiderman3.png";
import imagethirtyeight from "../../Assets/spiderman4.png";
import imagethirtynine from "../../Assets/Batmobile profilemaya.png";
import imagefourty from "../../Assets/Batmobile profile.jpg";

import imagefourtyone from "../../Assets/batman1.png";
import imagefourtytwo from "../../Assets/Finished.jpg";
import imagefourtythree from "../../Assets/Finished1.jpg";
import imagefourtyfour from "../../Assets/Finished2.png";
import imagefourtyfive from "../../Assets/Finished3.png";
import imagefourtysix from "../../Assets/Atmosphere1.jpg";
import imagefourtyseven from "../../Assets/sinjin.png";
import imagefourtyeight from "../../Assets/Lake.png";
import imagefourtynine from "../../Assets/plane1.png";
import imagefifty from "../../Assets/plane2.png";

function Animationpage() {

  const videos = [
    videoone,
    videothree,
    videofour,
    videotwo,
    videoseven,
    videoten,
    videoeight,
    videonine,
    videofive,
    videosix
  ];

  const modeling = [
    imagethirtyfive,
    imagethirtysix,
    imagethirtyseven,
    imagethirtyeight,
    imagethirtynine,
    imagefourty
  ];

  const renders = [
    imagefourtyone,
    imagefourtytwo,
    imagefourtythree,
    imagefourtyfour,
    imagefourtyfive,
    imagefourtysix,
    imagefourtyseven,
    imagefourtyeight,
    imagefourtynine,
    imagefifty
  ];

  return (
    <div className="aboutpagebackground">

      <Container>

        <h2 className="text-center mb-5">
          Animations <span> & Motion Graphics</span>
        </h2>

        {/* Video Section */}
        <h4 className="section-title">Animations</h4>

        <Row className="g-4">
          {videos.map((video, index) => (
            <Col lg={6} md={6} sm={12} key={index}>
              <video className="portfolio-video" controls>
                <source src={video} type="video/mp4" />
              </video>
            </Col>
          ))}
        </Row>

        {/* Modeling Section */}
        <h4 className="section-title mt-5">3D Modeling</h4>

        <Row className="g-4">
          {modeling.map((img, index) => (
            <Col lg={6} md={6} sm={12} key={index}>
              <img src={img} className="portfolio-image" alt="" />
            </Col>
          ))}
        </Row>

        {/* Renders Section */}
        <h4 className="section-title mt-5">Environment & Scene Renders</h4>

        <Row className="g-4">
          {renders.map((img, index) => (
            <Col lg={6} md={6} sm={12} key={index}>
              <img src={img} className="portfolio-image" alt="" />
            </Col>
          ))}
        </Row>

      </Container>

    </div>
  );
}

export default Animationpage;
